var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("iframe", {
      staticStyle: { width: "100%", height: "100vh" },
      attrs: { src: _vm.getFilesUrl(_vm.fileUrl), id: "iframe" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }